<div class="modal-header bg-gray-200 p-3 align-items-center">
  <button class="btn btn-link px-0 py-1 text-decoration-none"
    (click)="onMarkAll()"
    [disabled]="enableMarkAll"
  >{{ 'NOTIFICATIONS.MARK_ALL_AS_READ' | translate }}</button>
  <button class="btn btn-link px-0 py-1 color-gray-600" (click)="onClose()">
    <span class="d-flex"><i class="icon ni-close"></i></span>
  </button>
</div>
